import React, { useContext } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import CoreUpgradeIndicator from '@wix/da-ds/pkg/Indicators/CoreUpgrade';
import CoreBadge from '@wix/da-ds/pkg/Badges/CoreBadge';
import s from './CoreMenuItem.scss';
const CoreMenuItem = ({ className , hasCoreMembership , coreLevel  })=>{
    const { t  } = useTranslation();
    const isMobile = useContext(MobileContext);
    const usermenu_core_entry = useFlag('usermenu_core_entry');
    const buyCoreKey = isMobile ? 'siteHeaderMobile.userMenu.buyCoreMembership' : 'siteHeader.userMenu.buyCoreMembership';
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], className, hasCoreMembership && coreLevel && s[`package-${coreLevel}`])
    }, usermenu_core_entry ? /*#__PURE__*/ React.createElement(CoreUpgradeIndicator, null, hasCoreMembership && coreLevel ? t('siteHeader.userMenu.upgradeCoreMembership') : t('siteHeader.userMenu.buyCoreMembership.v2')) : /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("span", null, hasCoreMembership && coreLevel ? t(`siteHeader.userMenu.coreLabel.${coreLevel}`) : t(buyCoreKey)), /*#__PURE__*/ React.createElement("span", null, !hasCoreMembership && /*#__PURE__*/ React.createElement(CoreBadge, {
        corePackage: coreLevel,
        className: s['core-icon'],
        size: "large"
    }))));
};
CoreMenuItem.displayName = 'CoreMenuItem';
export default CoreMenuItem;
